import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import app from '../../main'
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  supplier_id: payload.supplier_id,
  email: payload.email,
  shipping_address: payload.shipping_address,
  delivery_time: payload.delivery_time,
  deadline: payload.deadline,
  freight: payload.freight,
  total_freight: payload.total_freight,
  tax_type: payload.tax_type,
  justify: payload.justify ? payload.justify : null,
  notes: payload.notes ? payload.notes : null
})
var crud = new Crud('PurchaseOrders', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  catalog: {
    currencies: [],
    suppliers: []
  },
  purchaseOrders: [],
  purchaseOrder: {
    details: []
  },
  supplierContacts: [],
  isModalOrderVisible: false,
  isModalSummaryVisible: false,
  isModalSessionOrderVisible: false,
  isSendPurchaseOrderModalVisible: false,
  isCancelPurchaseOrderModalVisible: false,
  suppliersFilter: [],
  projectsFilter: []
}

const mutations = {
  ...crud.mutations,
  SET_PURCHASE (state, payload) {
    state.purchaseOrders.unshift = payload
  },
  ADD_PRODUCT (state, payload) {
    const idx = state.purchaseOrder.details.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.purchaseOrder.details, idx, payload)
    } else {
      state.purchaseOrder.details.push(payload)
    }
  },
  DELETED_PRODUCTS_DETAIL (state, payload) {
    payload.forEach(product => {
      const idx = state.purchaseOrder.details.findIndex(u => u.id === product.id)
      if (idx >= 0) {
        Vue.delete(state.purchaseOrder.details, idx)
      }
    })
  },
  DELETED_PRODUCT_DETAIL (state, payload) {
    const idx = state.purchaseOrder.details.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.purchaseOrder.details, idx)
    }
  },
  SET_SUPPLIER_CONTACTS (state, payload) {
    state.supplierContacts = payload
  },
  SET_PURCHASE_INIT (state, payload) {
    state.purchaseOrder.details = payload
  },
  SET_MODAL_ORDER_VISIBLE (state, payload) {
    state.isModalOrderVisible = payload
  },
  SET_MODAL_SUMMARY_VISIBLE (state, payload) {
    state.isModalSummaryVisible = payload
  },
  SET_MODAL_SESSION_ORDER_VISIBLE (state, payload) {
    state.isModalSessionOrderVisible = payload
  },
  SET_SEND_PURCHASE_ORDER_MODAL (state, payload) {
    state.isSendPurchaseOrderModalVisible = payload
  },
  SET_CANCEL_PURCHASE_ORDER_MODAL (state, payload) {
    state.isCancelPurchaseOrderModalVisible = payload
  },
  SET_SUPPLIERS_FILTER (state, payload) {
    state.suppliersFilter = payload.data
  },
  SET_PROJECTS_FILTER (state, payload) {
    state.projectsFilter = payload.data
  }
}

const actions = {
  ...crud.actions,
  async savePurchase ({ commit }, payload) {
    let formData = new FormData()
    if (payload.form.files) {
      payload.form.files.forEach(file => {
        formData.append('files[]', file)
      })
    }
    formData.append('form', JSON.stringify({
      ...payload.form
    }))
    commit('Quotations/SET_LOADER_VISIBLE', true, { root: true })

    app.$Progress.start()
    try {
      const response = await axios.post(`purchase-orders`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('Quotations/SET_LOADER_VISIBLE', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('Quotations/SET_LOADER_VISIBLE', false, { root: true })
        commit('SET_PURCHASE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('Quotations/SET_LOADER_VISIBLE', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_MODAL_ORDER_VISIBLE', false)
      commit('Quotations/SET_LOADER_VISIBLE', false, { root: true })
      commit('SET_PURCHASE_INIT', [])
      setTimeout(() => {
        app.$router.push(`/purcharse-orders/${payload.form.requisition_id}/summary`)
      }, 200)
    }
  },
  printPurchase ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/purchase-orders/${payload}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  openFile ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${payload}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  deletedProductDetails ({ commit }, payload) {
    commit('DELETED_PRODUCT_DETAIL', payload)
  },
  deletedProductsDetails ({ commit }, payload) {
    commit('DELETED_PRODUCTS_DETAIL', payload)
  },
  setModalOrderVisible ({ commit }, payload) {
    commit('SET_MODAL_ORDER_VISIBLE', payload)
  },
  setModalSummaryVisible ({ commit }, payload) {
    commit('SET_MODAL_SUMMARY_VISIBLE', payload)
  },
  setModalSessionOrderVisible ({ commit }, payload) {
    commit('SET_MODAL_SESSION_ORDER_VISIBLE', payload)
  },
  setSendPurchaseOrderModalVisible ({ commit }, payload) {
    commit('SET_SEND_PURCHASE_ORDER_MODAL', payload)
  },
  setCancelPurchaseOrderModalVisible ({ commit }, payload) {
    commit('SET_CANCEL_PURCHASE_ORDER_MODAL', payload)
  },
  setPurchase ({ commit }, payload) {
    commit('SET_PURCHASE_INIT', payload)
  },
  loadSuppliers ({ dispatch }, payload) {
    dispatch('SupplierInvoices/loadSuppliers', payload, { root: true })
  },
  loadCurrenciesCatalog ({ dispatch }, payload) {
    dispatch('Quotations/loadCurrenciesCatalog', payload, { root: true })
  },
  loadRequisition ({ dispatch }, payload) {
    dispatch('Requisitions/loadRequisition', payload, { root: true })
  },
  setLoaderVisible ({ commit }, payload) {
    commit('Quotations/SET_LOADER_VISIBLE', payload, { root: true })
  },
  async loadSupplierContacts ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`suppliers/${payload}/contacts`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUPPLIER_CONTACTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadSuppliersFilter ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`suppliers?page=${payload.page}${payload.filters}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUPPLIERS_FILTER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load suppliers' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProjectsFilter ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects?page=${payload.page}${payload.filters}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PROJECTS_FILTER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load projects' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  purchaseOrders: state => state.purchaseOrders,
  purchaseOrder: state => state.purchaseOrder,
  supplierContacts: state => state.supplierContacts,
  isModalOrderVisible: state => state.isModalOrderVisible,
  isModalSessionOrderVisible: state => state.isModalSessionOrderVisible,
  isModalSummaryVisible: state => state.isModalSummaryVisible,
  isSendPurchaseOrderModalVisible: state => state.isSendPurchaseOrderModalVisible,
  isCancelPurchaseOrderModalVisible: state => state.isCancelPurchaseOrderModalVisible,
  suppliers: (state, getters, rootState, rootGetters) => rootGetters['SupplierInvoices/suppliers'],
  requisition: (state, getters, rootState, rootGetters) => rootGetters['Requisitions/requisition'],
  loader: (state, getters, rootState, rootGetters) => rootGetters['Quotations/loader'],
  currencies: (state, getters, rootState, rootGetters) => rootGetters['Quotations/currencies'],
  suppliersFilter: state => state.suppliersFilter,
  projectsFilter: state => state.projectsFilter
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
